export enum ModalDialogueSectionName {

	SECTION_MAIN = 'SECTION_MAIN',
	SECTION_FOOTER = 'SECTION_FOOTER'

}
